const rankingItems = [
  { rank: 1, title: '星辰大海', type: '电视剧', hot: '热度 9.8', change: 'up' },
  { rank: 2, title: '暗夜追光', type: '电视剧', hot: '热度 9.6', change: 'up' },
  { rank: 3, title: '欢乐喜剧人·第八季', type: '综艺', hot: '热度 9.4', change: 'up' },
  { rank: 4, title: '山海传说', type: '动画电影', hot: '热度 9.2', change: 'new' },
  { rank: 5, title: '极限挑战·巅峰季', type: '综艺', hot: '热度 9.0', change: 'down' },
];

export default function SectionRanking() {
  return (
    <section id="ranking" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            热播榜单
          </h2>
          <p className="text-sm text-foreground-500">实时热度排行，大家都在看</p>
        </div>
        <div className="bg-background-50 rounded-lg border border-background-200 overflow-hidden">
          {rankingItems.map((item, i) => (
            <div
              key={i}
              className={`flex items-center gap-4 px-5 py-4 border-b border-background-100 last:border-0 hover:bg-background-100 transition-colors cursor-pointer ${
                i === 0 ? 'bg-accent-50/50' : ''
              }`}
            >
              <span
                className={`w-7 h-7 flex items-center justify-center rounded-full text-xs font-bold ${
                  i === 0
                    ? 'bg-accent-500 text-white'
                    : i === 1
                    ? 'bg-primary-500 text-white'
                    : i === 2
                    ? 'bg-secondary-500 text-white'
                    : 'bg-background-200 text-foreground-500'
                }`}
              >
                {item.rank}
              </span>
              <div className="flex-1 min-w-0">
                <p className="text-sm font-semibold text-foreground-900 truncate">{item.title}</p>
                <p className="text-xs text-foreground-400">{item.type}</p>
              </div>
              <div className="flex items-center gap-2">
                {item.change === 'up' && (
                  <span className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-arrow-up-line text-accent-500 text-xs"></i>
                  </span>
                )}
                {item.change === 'down' && (
                  <span className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-arrow-down-line text-foreground-400 text-xs"></i>
                  </span>
                )}
                {item.change === 'new' && (
                  <span className="px-1.5 py-0.5 bg-primary-100 text-primary-700 text-xs font-medium rounded">
                    NEW
                  </span>
                )}
                <span className="text-xs text-foreground-500 whitespace-nowrap">{item.hot}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}